export enum FeatureFlagTypes {
  Salesforce = 'salesforce',
  ServiceNow = 'service_now',
  AdoptionDashboard = 'adoption_dashboard',
  RiskDashboard = 'risk_dashboard',
  AiExtensions = 'ai_extensions',
  EnterpriseAiDashboard = 'enterprise_ai_dashboard',
  EnterpriseAiDetection = 'enterprise_ai_detection',
  MockPolicyDetectionRules = 'mock_policy_detection_rules',
  ChatGptEnterprise = 'chat_gpt_enterprise',
  AmazonBedrock = 'amazon_bedrock',
  Google = 'google',
  Devices = 'devices',
  Budibase = 'budibase',
  Airtable = 'airtable',
  Cursor = 'spm_cursor_platform',
  IssuesPage = 'issues_page',
  IssueTriggeredPlaybooks = 'dr_issue_triggered_playbooks',
  AIRuntimePreventionMockTab = 'airuntime_prevention_mock_tab',
  AIRuntimeDataInsightsTab = 'airuntime_data_insights_tab',
  DataLayerPage = 'data_layer_page',
  PoliciesRulesExportCsvButton = 'policies_rules_export_csv_button',
  InlinePrevention = 'inline_prevention',
  BrownfieldPlaybooks = 'brownfield_playbooks',
  FindingsPlaybooks = 'findings_playbooks',
  FindingsLabels = 'findings_labels',
  AgentPlatformWidget = 'agent_platform_widget',
  RuntimeRiskWidget = 'runtime_risk_widget',
  AiThreadsView = 'ai_threads_view',
  rbacAccessManagement = 'core_rbac_access_management',
  BlockPolicyPage = 'block_policy_page',
  BlockLegacyIntegrations = 'block_legacy_integrations',
  OutpostPowerPlatform = 'outpost_powerplatform',
  DrOutpostFetchSensitiveDataEnabled = 'dr_outpost_fetch_sensitive_data_enabled',
  EnableAdaptersLayout = 'core_enable_adapters_layout',
  EnableSendToSoc = 'core_enable_send_to_soc',
  CoreDisableUnleash = 'core_disable_unleash',
  ZenAI = 'core_enable_zen_ai',
  EnableNewIntegrationPageLayout = 'core_enable_new_integration_page_layout',
  ViolationStatusPlaybookExecHistory = 'spm_violation_status_playbook_exec_hist',
  EnableAccountPolicyLayout = 'core_enable_account_policy_layout',
  DrInventoryEnrichment = 'dr_inventory_enrichment_inventory_id',
  UnifiedPipeline = 'dr_unified_pipeline',
  RedTeaming = 'spm_red_teaming',
  RsaDemoRuntimeBoundaries = 'react_rsa_2026_demo_runtime_boundaries',
  ReactMigrationOverview = 'react_migration_enable_overview_route',
  ReactMigrationSettings = 'react_migration_enable_settings_route',
  ReactMigrationAdapters = 'react_migration_enable_adapters_route',
  ReactMigrationPolicies = 'react_migration_enable_governance_policies_route',
  ReactMigrationPlaybooks = 'react_migration_enable_governance_playbooks_route',
  ReactMigrationRedTeaming = 'react_migration_enable_governance_red_teaming_route',
  ReactMigrationFindings = 'react_migration_enable_findings_route',
  ReactMigrationInLineControl = 'react_migration_enable_in_line_control_route',
  ReactMigrationViolations = 'react_migration_enable_violations_route',
  ReactMigrationHygiene = 'react_migration_enable_hygiene_route',
  ReactMigrationInventory = 'react_migration_enable_inventory_route',
  ReactMigrationActivity = 'react_migration_enable_activity_route',
  ReactMigrationDataLens = 'react_migration_enable_data_lens_route',
  ReactMigrationAdoption = 'react_migration_enable_adoption_route',
  ReactMigrationIssues = 'react_migration_enable_issues_route',
  ReactRsa2026DemoRuntimeBoundaries = 'react_rsa_2026_demo_runtime_boundaries',
  ReactHideIssuesPreviewBadge = 'react_hide_issues_preview_badge',
  ReactHideInlineControlPage = 'react_hide_inline_control_page',
  ReactHideIssuesPreviewBanner = 'react_hide_issues_preview_banner',
  SpmNrtEnabled = 'spm_nrt_enabled',
  SpmIamDemoAmex = 'spm_iam_demo_amex',
  SpmOwaspNhi = 'spm_owasp_nhi',
}
